import React from 'react'
import "./style.css"

function RenderCustomerUserProfile({profile}) {
    return (
        <div className="customer-user-pic" style={{ "backgroundColor": profile.Color }}>
            {profile.Letter}
        </div>
    )
}

export default RenderCustomerUserProfile
